var _g, _metadata;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 726,
    height: 730,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "imagebot_2"
  }, /*#__PURE__*/React.createElement("title", null, "imagebot_2"), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 1.95313) matrix(0.812081 0 0 0.812081 23.4375 15.625)",
    d: "M 4.38321 426.296 L 4.38321 426.296 C 4.38321 193.28 193.28 4.38321 426.296 4.38321 L 426.296 4.38321 C 538.193 4.38321 645.509 48.8347 724.633 127.959 C 803.757 207.082 848.208 314.398 848.208 426.296 L 848.208 426.296 C 848.208 659.31 659.31 848.208 426.296 848.208 L 426.296 848.208 C 193.28 848.208 4.38321 659.31 4.38321 426.296 Z",
    id: "imagebot_43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 20,
    stroke: "#000000",
    fill: "#fff"
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "image/svg+xmlOpenclipartStriped Ball2013-08-26T15:48:18A striped ball.https://openclipart.org/detail/182218/striped-ball-by-gustavorezende-182218gustavorezendeballcirclespherestripedstripes")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropCircle);
export default __webpack_public_path__ + "static/media/dropCircle.de7d9c1f164164e3963854e255fb42dd.svg";
export { ForwardRef as ReactComponent };